import { render, staticRenderFns } from "./ConnectInstagramModal.vue?vue&type=template&id=7455d0ca"
import script from "./ConnectInstagramModal.vue?vue&type=script&lang=js"
export * from "./ConnectInstagramModal.vue?vue&type=script&lang=js"
import style0 from "./ConnectInstagramModal.vue?vue&type=style&index=0&id=7455d0ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports